import React, { useState, useEffect, useRef } from "react";
import SearchBar from "./searchBar";
import Content from "../content/content";
import { getFeedNormal } from "../../api";
import { searchPost } from "../../api";

function SearchPostFeed({
  dataList,
  bookmarksInit,
  cursorInit,
  users,
  search,
  setSearch,
}) {
  const [posts, setPosts] = useState(dataList);
  const [cursor, setCursor] = useState(cursorInit);
  const [offset, setOffset] = useState(0);
  const [cursorSearch, setCursorSearch] = useState("");
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setSearch(search);
    if (search !== "") {
      setPosts([]);
      setOffset(0); // Réinitialise l'offset à chaque nouvelle recherche
      setCursorSearch("");
      getSearchFeed(0, controller.signal);
    } else {
      setPosts([]);
      setCursorSearch("");
      getFeed();
    }
    return () => {
      controller.abort();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleChange = (event) => {
    setOffset(0);
    setSearch(event);
  };

  const uniqueArray = (arr1, arr2) => {
    let ids = arr1.map((item) => {
      return item.id;
    });
    return arr2.filter((item) => {
      return !ids.includes(item.id);
    });
  };

  function getFeed(init = false) {
    if (cursor !== false) {
      getFeedNormal(cursor).then((data) => {
        if (cursor === "" && data.data.length === 0) {
          setCursorSearch("");
          setCursor(data.cursor);
          setPosts([]);
        } else {
          let newList = posts.concat(uniqueArray(posts, data.data));

          setCursorSearch("");
          setCursor(data.cursor);
          setPosts(newList);
        }
      });
    }
  }

  function getSearchFeed(currentOffset = offset, signal) {

    searchPost(cursorSearch,search, currentOffset, { signal }).then(data => {
      let newList = currentOffset === 0 ? data.data : posts.concat(uniqueArray(posts, data.data));
      setPosts(newList);
      setOffset(currentOffset + data.offset);
      setCursorSearch(data.cursor);
    }).catch(e => {
      if (e.name !== "AbortError") throw e;
    });
  }
  return (
    <>
      <div className="c-container_search-bar">
        <SearchBar
          value={search}
          handleChange={(e) => handleChange(e.target.value)}
        />
      </div>
      <div className="c-container_infos main-data c-infos_postfeed">
        {posts.length > 0 && (
          <Content
            users={users}
            apiCall={search.length < 1 ? getFeed : getSearchFeed}
            postList={posts}
            bookMarks={bookmarksInit}
            cursor={search.length < 1 ? cursor : cursorSearch}
          />
        )}
      </div>
    </>
  );
}

export default SearchPostFeed;
